import { render, staticRenderFns } from "./sfc-header-slim-no-ad.vue?vue&type=template&id=d66c2580&lang=pug&"
import script from "./sfc-header-slim-no-ad.vue?vue&type=script&lang=js&"
export * from "./sfc-header-slim-no-ad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports